import { useContext } from "react";
import { GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../../context/i18n.context";
import { cardStyle, sectionTitleStyle } from "../cardStyles";

const ExclusionsCard = () => {
  const {
    state: { translate },
  } = useContext(I18nContext);

  const items = [
    translate("newDashboard.policyPage.exclusions.suicide"),
    translate("newDashboard.policyPage.exclusions.intentional"),
    translate("newDashboard.policyPage.exclusions.war"),
    translate("newDashboard.policyPage.exclusions.extreme"),
  ];

  return (
    <div style={cardStyle}>
      <div style={sectionTitleStyle}>
        <GlobalIcon iconName="AlertCircleIcon" size="XS" color="#d97706" />
        <h2 style={{ fontSize: 18, fontWeight: 700, color: "#111827", margin: 0 }}>
          {translate("newDashboard.policyPage.exclusions")}
        </h2>
      </div>

      <ul
        style={{
          margin: 0,
          padding: "0 0 0 20px",
          display: "flex",
          flexDirection: "column",
          gap: 10,
        }}
      >
        {items.map((text, idx) => (
          <li key={idx} style={{ fontSize: 14, color: "#4b5563", lineHeight: 1.5 }}>
            {text}
          </li>
        ))}
      </ul>

      <p
        style={{
          fontSize: 13,
          color: "#6b7280",
          fontStyle: "italic",
          marginTop: 16,
          paddingTop: 12,
          borderTop: "1px solid #f3f4f6",
        }}
      >
        {translate("newDashboard.policyPage.exclusions.fullDetails")}
      </p>
    </div>
  );
};

export default ExclusionsCard;
